import React, { Component } from 'react';

class NoMatch extends Component {
  render() {
    return (
      <p className="NoMatch-intro">
        Sorry, page not found.
      </p>
    );
  }
}

export default NoMatch;



// WEBPACK FOOTER //
// ./src/components/Page/NoMatch/NoMatch.js